import { render, staticRenderFns } from "./MedicinesTypeEdit.vue?vue&type=template&id=66064cea&scoped=true&"
import script from "./MedicinesTypeEdit.vue?vue&type=script&lang=js&"
export * from "./MedicinesTypeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66064cea",
  null
  
)

export default component.exports